module.exports={
  "name": "pict",
  "version": "1.0.372",
  "description": "Pict browser library.",
  "main": "source/Pict.js",
  "scripts": {
    "start": "node source/Pict.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "coverage": "npx quack coverage",
    "build": "npx quack build",
    "prepublishOnly": "npx quack build",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-image:local",
    "docker-dev-run": "docker run -it -d --name pict-dev -p 37447:8080 -p 19506:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-image:local",
    "docker-dev-shell": "docker exec -it pict-dev /bin/bash",
    "lint": "eslint source/**/*.js test/**/*.js",
    "types": "tsc -p ."
  },
  "files": [
    "source/",
    "dist/",
    "types/"
  ],
  "types": "types/source/Pict.d.ts",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "repository": {
    "type": "git",
    "url": "git+https://stevenvelozo@github.com/stevenvelozo/pict.git"
  },
  "author": "steven velozo <steven@velozo.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/stevenvelozo/pict/issues"
  },
  "homepage": "https://github.com/stevenvelozo/pict#readme",
  "devDependencies": {
    "@eslint/js": "^9.39.1",
    "@types/jquery": "^3.5.33",
    "@types/sinon": "^17.0.4",
    "eslint": "^9.39.1",
    "globals": "^16.5.0",
    "pict-docuserve": "^1.3.2",
    "quackage": "^1.2.3",
    "sinon": "^20.0.0",
    "typescript": "^5.9.3"
  },
  "dependencies": {
    "cachetrax": "^1.0.6",
    "fable": "^3.1.74",
    "pict-application": "^1.0.34",
    "pict-provider": "^1.0.13",
    "pict-template": "^1.0.15",
    "pict-view": "^1.0.68"
  }
}
